import { Spinner } from '@/shared/ui/spinner';

/** La schermata di attesa a tutta pagina: avvio, route protette, import lazy delle pagine. */
export default function AppLoadingScreen({ message }: { message: string }) {
  return (
    <div
      role="status"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas"
    >
      <Spinner size="lg" label={null} />
      <p className="text-sm font-medium text-muted">{message}</p>
    </div>
  );
}
